import { proxy } from 'valtio';
import {
  HTTP_HEADER_SOUND_CLIENT_KEY,
  HTTP_HEADER_SOUND_WEBAPP_VERSION,
} from '@soundxyz/utils/const';
import { CLIENT_API_KEY } from '@utils/env';

type Headers = {
  [key in typeof HTTP_HEADER_SOUND_CLIENT_KEY]: string;
} & {
  [key in typeof HTTP_HEADER_SOUND_WEBAPP_VERSION]: string;
} & {
  'auth-token'?: string;
  'user-agent'?: string;
};

export const graphqlClientHeaders: Headers = proxy({
  [HTTP_HEADER_SOUND_CLIENT_KEY]: CLIENT_API_KEY,
  [HTTP_HEADER_SOUND_WEBAPP_VERSION]: String(process.env.NEXT_PUBLIC_WEBAPP_VERSION),
});

if (typeof localStorage !== 'undefined') {
  const authToken = localStorage.getItem('auth-token');
  if (authToken) {
    graphqlClientHeaders['auth-token'] = authToken;
  }
}

if (typeof window === 'undefined') {
  graphqlClientHeaders['user-agent'] = 'soundxyz';
}
